import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetUserDashboardResponse } from './get-user-dashboard-response';
import { getUserDashboardResponseSchema } from './get-user-dashboard-response';

export async function getUserDashboardApi(
  userId: string,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetUserDashboardResponse>> {
  return getRequest<IGetUserDashboardResponse>({
    path: `/sys/users/${userId}/dashboard`,
    schema: getUserDashboardResponseSchema,
    options,
  });
}
